import Input from '@/components/ui/input/index.vue';

export default {
  name: 'pagination',
  components: {
    Input
  },
  props: {
    input: {
      type: Boolean,
      required: false,
      default: false,
    },
    position: {
      type: String,
      required: false,
    },
    totalPage: {
      type: [Number, String],
      required: true,
      default: 10,
    },
    nowPage: {
      type: [Number, String],
      required: true,
      default: 1,
    },
    range: {
      type: [Number, String],
      required: true,
      default: 5,
    }
  },
  data() {
    return {
      value: this.nowPage,
      inputValue: this.nowPage,
      //:style="horizontalPosition"
    }
  },
  watch: {
    nowPage: {
      handler: function (n) {
        this.value = n
        this.inputValue = n
      }
    },
    value: {
      handler: function () {
        this.$emit('changePage', this.value)
      }
    },
    inputValue: function (n) {
      this.value = n
    },
  },
  computed: {
    horizontalPosition() {
      return this.position
    },
    current: {
      get() {
        return parseInt(this.nowPage);
      },
      set(val) {
        // this.$emit('changePage', val);
        this.value = val
      },
    },
    pageRange() {
      const left = this.current - parseInt(this.range / 2);
      let right = parseInt(this.range / 2) + this.current;

      // const left = this.current - this.range;
      // console.log(right,left)

      const arr = [];
      if (this.totalPage >= 5) {
        if (this.range % 2 > 0) {
          right += 1;
        }
        for (let i = left; i < right; i++) {
          if (i <= this.totalPage && i >= 1) {
            arr.push(i);
          }
        }
        for (let i = arr.length; i <= this.range; i++) {
          if (arr.length < this.range) {
            if (Number(arr[0]) === 1) {
              arr.push(arr[arr.length - 1] + 1);
            } else {
              arr.unshift(arr[0] - 1);
            }
          }
        }
      } else {
        for (let i = 0; i < this.totalPage; i++) {
          arr.push(i + 1);
        }
      }
      // console.log('f',arr)
      return arr;
    }
  },
  mounted() {
  },
  methods: {
    onChange(e) {
      this.inputValue = 0
      let num = null
      if (e.target.value) {
        num = parseInt(e.target.value)
      } else {
        num = 1
      }

      if (num > this.totalPage) {
        this.inputValue = this.totalPage
      } else if (num < 1) {
        this.inputValue = 1
      } else {
        this.inputValue = num
      }
    },
    setActiveClass(number) {
      return {
        ["active"]: number === this.current,
      };
    },
    changePage(current) {
      // console.log(current, 'current');
      if (current === "prev") {
        if (this.current - 1 <= 0) return;
        this.current -= 1;
      } else if (current === "next") {
        if (this.current + 1 > this.totalPage) return;
        this.current += 1;
      } else if (current === "start") {
        this.current = 1;
      } else if (current === "end") {
        this.current = this.totalPage;
      } else {
        this.current = current;
      }
    }
  }
}


